module.exports = __webpack_public_path__ + "static/media/reactlogo.9b864b36.png";